import React,  {useState} from 'react';
import {observer} from 'mobx-react-lite'
import Btn from '../../../ui/Btn'
import clubStore from '../../../storage/ClubStore'
import appStore from '../../../storage/AppStore'
import {Button} from 'primereact/button'
import {Column} from 'primereact/column'
import {DataTable} from 'primereact/datatable'
import {Tag} from 'primereact/tag'
import Input from '../../../ui/Input'
import {Dialog} from 'primereact/dialog'

const MemberModal = () => {
  const [visible, setVisible] = useState(false);
  
  const itemTemplate = (member) => {
    return (
      <div className={`flex justify-content-around align-items-center ${member.selected ? 'bg-green-50' : ''}`}>
        <div className="col-2">
          {member.is_member ? (
            <i className="pi pi-check" style={{fontSize: '1.5rem'}} onClick={() => {
              clubStore.deleteTeamMember(member.id).then(() => {
                clubStore.getTeam(clubStore.team.id);
              })
            }}/>
          ) : (
            <i className="pi pi-stop" style={{fontSize: '1.5rem'}} onClick={() => {
              clubStore.addTeamMembers([member.id]).then(() => {
                clubStore.getTeam(clubStore.team.id);
              })
            }}/>
          )}
        </div>
        <div className="col-8">
          {member.year_born && <Tag value={member.year_born}/>} {member.title}
        </div>
      </div>
    )
  }
  
  return (
    <>
      <Button icon="pi pi-users"
              size="small"
              severity="secondary"
              label={appStore.tr.add_member}
              onClick={() => {
                setVisible(true);
                clubStore.getFreeMembers();
              }}
      />
      <Dialog header={appStore.tr.add_member} visible={visible} style={{width: '95vw'}} onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}>
        <div className={"grid"}>
          <div className="col-12 flex justify-content-start align-items-center mt-1">
            <Input type="text" store={clubStore.freeMemberQuery} prop={"title"}
                   label={appStore.tr.title} className="w-8rem mr-2"/>
            <Input type="text" store={clubStore.freeMemberQuery} prop={"year_born"}
                   label={appStore.tr.year_born} className="w-8rem mr-2"/>
            <Btn icon="pi pi-search" onClick={() => clubStore.getFreeMembers()}/>
          </div>
          <DataTable value={clubStore.freeMembers} emptyMessage={appStore.tr.not_found}
                     className="w-full">
            <Column field={"title"} body={itemTemplate}/>
          </DataTable>
        </div>
      </Dialog>
    </>
  );
}

export default observer(MemberModal);